import arriving from './arriving';
import judging from './judging';
import qc from './qc';
import qcReceiving from './qc-receiving';
import receiving from './receiving';

export default [...qc, ...arriving, ...qcReceiving, ...judging, ...receiving];
